import React, { useState } from 'react';

interface IProps {
  closeModal: () => void;
}

const LocationServiceClosuerNotice: React.FC<IProps> = ({ closeModal }: IProps) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleDontShowAgain = () => {
    setDontShowAgain(!dontShowAgain);
  };

  const handleClose = () => {
    if (dontShowAgain) {
      // Set the current date as value - this will expire at the end of the day
      const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
      localStorage.setItem('hideLocalStitchLocationServicePopup', today);
    }
    closeModal();
  };

  return (
    <div className="dimd-layer">
      <div className="announcement-popup">
        <div className="announcement-header">
          <h2>위치기반서비스사업 폐업 통보 안내문</h2>
          <button type="button" className="btn-close" onClick={handleClose}>
            <span className="img-close" />
          </button>
        </div>

        <div className="announcement-content">
          <div className="announcement-text">
            <p>고객님들께 「위치정보의 보호 및 이용 등에 관한 법률」 제11조에 따라</p>
            <p>아래와 같이 위치기반서비스사업 종료를 안내 드립니다.</p>

            <p className="spacing" />

            <p>- 사업자명: 디앤디프라퍼티솔루션 ㈜</p>
            <p>- 위치기반서비스사업의 범위: 로컬스티치 어플리케이션 내 이용자 위치기반 서비스 사업</p>
            <p>- 폐업 예정일: 2025년 12월 19일</p>
            <p>- 폐업사업명: 로컬스티치 - 내 주변 지점 찾기, 가까운 공간, 가까운 회의실, 가까운 리테일</p>

            <p className="spacing" />

            <p>지금까지 이용해주신 모든 분들께 감사드립니다.</p>
            <p>2025년 11월 20일</p>
            <p>디앤디프라퍼티솔루션㈜</p>
            <p className="signature">대표이사 오영래</p>
          </div>

          <div className="dont-show-again">
            <div className="checkbox-wrapper">
              <input
                type="checkbox"
                id="dontShowCheckbox"
                checked={dontShowAgain}
                onChange={handleDontShowAgain}
              />
              <label htmlFor="dontShowCheckbox">오늘 하루 그만보기</label>
            </div>
            <button type="button" onClick={handleClose}>
              닫기
            </button>
          </div>
        </div>
      </div>
      <style jsx>{`
        .dimd-layer {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          z-index: 1000;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }

        .announcement-popup {
          position: relative;
          background-color: white;
          width: 100%;
          max-width: 650px;
          max-height: 90vh;
          overflow-y: auto;
          padding: 40px 30px;
          border-radius: 0;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .announcement-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 25px;
        }

        .btn-close {
          position: static;
          background: none;
          border: none;
          cursor: pointer;
          line-height: 1;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }

        .btn-close .img-close {
          display: block;
          width: 100%;
          height: 100%;
          background-image: url('/images/x-button.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
        }

        .announcement-content {
          text-align: left;
        }

        h2 {
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 25px;
          text-align: left;
          letter-spacing: -0.5px;
          margin: 0;
        }

        .announcement-text {
          line-height: 1.5;
          margin-bottom: 30px;
          font-size: 15px;
          color: #000;
          letter-spacing: -0.5px;
        }

        .announcement-text p {
          margin-bottom: 5px;
        }

        .spacing {
          height: 10px;
        }

        .signature {
          margin-top: 20px;
          /* text-align: right; */
        }

        .dont-show-again {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-top: 1px solid #000;
          padding-top: 15px;
          padding-left: 0;
        }

        .checkbox-wrapper {
          display: flex;
          align-items: center;
          padding-left: 0;
          margin-left: 0;
        }

        .dont-show-again input[type='checkbox'] {
          appearance: none;
          -webkit-appearance: none;
          /* width: 16px; */
          /* height: 16px; */
          /* border: 1px solid #000; */
          /* border-radius: 2px; */
          /* margin-right: 8px; */
          margin-left: 0;
          position: relative;
          cursor: pointer;
          vertical-align: middle;
        }

        .dont-show-again input[type='checkbox']:checked {
          background-color: #fff;
          border-color: #ccc;
        }

        .dont-show-again input[type='checkbox']:checked:after {
          content: '';
          position: absolute;
          left: 4px;
          top: 1px;
          width: 5px;
          height: 10px;
          border: solid #333;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }

        .dont-show-again label {
          font-size: 15px;
          height: 18px;
          line-height: 18px;
          cursor: pointer;
        }

        .dont-show-again button {
          padding-bottom: 1px;
          border-bottom: 1px solid #000;
          cursor: pointer;
          font-size: 15px;
        }

        @media (max-width: 768px) {
          .announcement-popup {
            padding: 30px 20px;
          }

          h2 {
            font-size: 18px;
          }

          .announcement-text {
            font-size: 13px;
          }

          .announcement-popup {
            padding: 30px 20px;
            max-height: 70vh;
          }

          .btn-close .img-close {
            width: 20px;
            height: 20px;
          }

          .dont-show-again {
            font-size: 13px;
          }

          .dont-show-again label {
            font-size: 13px;
          }

          .dont-show-again button {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
};

export default LocationServiceClosuerNotice;
